// Fire a Matomo page view on every navigation — both hard loads and SPA transitions.
// The Matomo init script (in seo.jsx) loads matomo.js and sets up the _paq queue;
// setCustomUrl ensures Matomo records the correct URL for each client-side navigation.
exports.onRouteUpdate = ({ location }) => {
  if (typeof window._paq === 'undefined') return;
  window._paq.push(['setCustomUrl', location.pathname + location.search]);
  window._paq.push(['setDocumentTitle', document.title]);
  window._paq.push(['trackPageView']);
};

exports.shouldUpdateScroll = ({ routerProps }) => {
  console.log(routerProps.location.pathname);
  if (routerProps?.location?.pathname.includes('blog/')) {
    return false;
  }
};
